import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../services/apiService';
import { mapState, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
export default {
  name: 'ViewUserProfile',
  data: function data() {
    var _this = this;

    return {
      showAddressData: false,
      addressPanel: null,
      contactPanel: null,
      buttons01: [{
        title: this.$i18n_t('Common.save'),
        dataCy: 'btn_save_profile',
        icon: 'fas fa-save',
        action: 'saveUserProfile',
        valid: true
      }],
      buttons02: [{
        title: this.$i18n_t('accMgmt.user.changePassword'),
        dataCy: 'btn_save_password',
        icon: 'fas fa-save',
        action: 'handlePwdUpdate',
        valid: true
      }],
      userObject: {
        properties: {
          address: {
            street: null,
            houseNumber: null,
            postalCode: null,
            city: null,
            region: null,
            country: null
          },
          contactInfo: {
            phone: null,
            mobile: null
          }
        }
      },
      mfaDialog: false,
      mfaDialogDisable: false,
      mfaEnabled: false,
      valid: false,
      valid2: false,
      password1: '',
      password2: '',
      pwOld: '',
      passwordPolicy: {},
      passwordError: null,
      emailRules: [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }, function (v) {
        return /.+@.+\..+/.test(v) || _this.$i18n_t('Common.emailValid');
      }],
      reqRules: [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }]
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['image', 'color', 'inpOutlined', 'inpFilled'])), mapState('authentication', ['user', 'isImpersonating'])), {}, {
    passwordIsValid: function passwordIsValid() {
      return this.password1 === this.password2;
    },
    passwordHasError: function passwordHasError() {
      return this.passwordError && typeof this.passwordError === 'string';
    },

    /*password2Rules() {
      return [(v) => (!!v && v === this.password1) || this.$i18n_t('accMgmt.user.pwdMissmatch')];
    },
    passwordRules() {
      return [
        (v) => !!v || this.$i18n_t('accMgmt.user.passwordErrors.USER_PASSWORD_REQUIRED'),
        // validatePassword returns a promise, but this rules-method must return a string or bool
        // so just perform a typecheck to "convert" into boolean
        (v) => (!!v && typeof this.validatePassword() === 'string') || true,
      ];
    },*/
    userPrimaryTenantId: function userPrimaryTenantId() {
      return get(get(this.userObject, 'access', []).filter(function (a) {
        return a.primary;
      }), '[0].tenantId');
    },
    passwordRules: function passwordRules() {
      var _this2 = this;

      return {
        passNew: function passNew(v) {
          return !!v || _this2.$i18n_t('accMgmt.user.passwordErrors.USER_PASSWORD_REQUIRED');
        },
        passRepeat: function passRepeat(v) {
          return v === _this2.password1 || _this2.$i18n_t('accMgmt.user.pwdMissmatch');
        }
      };
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    return ApiService.getUser(this).then(function (user) {
      _this3.userObject = user;

      if (!user.properties) {
        _this3.userObject.properties = {};
      }

      if (!user.properties.address) {
        _this3.userObject.properties.address = {};
      }

      if (!user.properties.contactInfo) {
        _this3.userObject.properties.contactInfo = {};
      }

      _this3.mfaEnabled = get(_this3.userObject, 'properties.2fa.enabled', false);
      return ApiService.tenantGetPasswordPolicy(_this3.userPrimaryTenantId);
    }).then(function (passwordPolicy) {
      _this3.passwordPolicy = passwordPolicy;
    }).catch(function (error) {
      if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
        _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
      } else {
        _this3.$snack('Failed to load User', 'error');
      }
    }).finally(function () {
      _this3.$store.state.app.loading = false;
    });
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    validate: function validate(form) {
      if (this.$refs[form].validate()) {
        this.snackbar = true;
      }
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;

      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.validate('userForm');
      ApiService.updateUser(this.userObject).then(function (user) {
        _this4.userObject = user.data;

        _this4.$snack(_this4.$i18n_t('Common.userUpdated'), 'success');
      }).catch(function (error) {
        if (error.response && _this4.$i18n_t("Error.".concat(error.response.data.message))) {
          _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this4.$snack(_this4.$i18n_t('Common.userUpdatedFail'), 'error');
        }
      }).finally(function () {
        _this4.$store.state.app.loading = false;
      });
    },
    handlePwdUpdate: function handlePwdUpdate() {
      this.validate('passwordForm');
      this.updatePassword();
    },
    validatePassword: debounce(function () {
      var _this5 = this;

      return ApiService.validateUserPassword(this.password1, this.userPrimaryTenantId).then(function (result) {
        if (typeof result === 'string') {
          var matches = result.match(/(.+?)_([0-9]+)$/); // special handling: length is encoded in error-message

          if (matches && matches.length) {
            var length = parseInt(matches[2]);
            var message = matches[1];
            _this5.passwordError = _this5.$i18n_tc("accMgmt.user.passwordErrors.".concat(message), length, {
              n: length
            });
          } else {
            _this5.passwordError = _this5.$i18n_t("accMgmt.user.passwordErrors.".concat(result));
          }
        } else {
          _this5.passwordError = null;
        }
      });
    }, 250),
    updatePassword: function updatePassword() {
      var _this6 = this;

      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.submitted = true;

      if (!this.passwordIsValid) {
        this.$snack(this.$i18n_t('accMgmt.user.pwdMissmatch'), 'error');
        return;
      }

      return ApiService.updatePassword(this.userObject.id, this.pwOld, this.password1).then(function () {
        _this6.$snack(_this6.$i18n_t('accMgmt.user.pwdChgSuccess'), 'success');
      }).catch(function (error) {
        if (error.response && _this6.$i18n_t("Error.".concat(error.response.data.message))) {
          _this6.$snack(_this6.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          if (error.response.data.statusCode === 400) {
            _this6.$snack(_this6.$i18n_t('accMgmt.user.pwdChgFailSame'), 'error');
          } else {
            _this6.$snack(_this6.$i18n_t('accMgmt.user.pwdChgFail'), 'error');
          }
        }
      }).finally(function () {
        _this6.$store.state.app.loading = false;
      });
    },
    saveUserProfile: function saveUserProfile() {
      this.handleSubmit();
    },
    handleToggle2fa: function handleToggle2fa() {
      if (this.mfaEnabled) {
        this.mfaDialogDisable = true;
        this.mfaDialog = false;
      } else {
        this.mfaDialog = true;
        this.mfaDialogDisable = false;
      }
    },
    resetValidate: function resetValidate() {
      this.$refs.passwordForm.resetValidation();
      this.passwordError = null;
    }
  })
};